import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useVersionStore } from '../../store/versionStore';

export const SimulationDetail = () => {
  const { simulationId } = useParams<{ simulationId: string }>();
  const navigate = useNavigate();
  const fetchSimulations = useVersionStore((state) => state.fetchSimulations);
  const fetchVersions = useVersionStore((state) => state.fetchVersions);
  const getSimulation = useVersionStore((state) => state.getSimulation);
  const getLatestVersion = useVersionStore((state) => state.getLatestVersion);
  const [status, setStatus] = useState<'loading' | 'not-found'>('loading');

  useEffect(() => {
    if (!simulationId) {
      setStatus('not-found');
      return;
    }

    const redirectToWorkspace = async () => {
      try {
        await fetchSimulations();
        await fetchVersions(simulationId);

        const simulation = getSimulation(simulationId);
        if (!simulation) {
          setStatus('not-found');
          return;
        }

        const latestVersion = getLatestVersion(simulationId);

        if (latestVersion) {
          navigate(`/workspace?simulation=${simulation.id}&version=${latestVersion.id}`, { replace: true });
        } else {
          navigate(`/workspace?simulation=${simulation.id}`, { replace: true });
        }
      } catch (error) {
        console.error('Error redirecting to workspace:', error);
        setStatus('not-found');
      }
    };

    redirectToWorkspace();
  }, [simulationId, fetchSimulations, fetchVersions, getSimulation, getLatestVersion, navigate]);

  if (status === 'not-found') {
    return (
      <div className="simulation-detail-container">
        <div className="error-container">
          <h2>Model not found</h2>
          <button className="btn btn-primary" onClick={() => navigate('/simulations')}>
            Back to Models
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="simulation-detail-container">
      <div className="loading-container">
        <div className="loading-spinner">Opening latest version...</div>
      </div>
    </div>
  );
};
